import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { SALES_DATA_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updateProductSalesDataAction = createAsyncThunk(
    'price/updateProductSalesDataAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.put(`${ SALES_DATA_PATH }/${ data.productId }`, data.form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateProductSalesDataSlice = createSlice({
    name: 'updateProductSalesDataSlice',
    initialState: DEFAULT_STATE,
    extraReducers: builder => {
        builder.addCase(updateProductSalesDataAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateProductSalesDataAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateProductSalesDataAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateProductSalesDataState = (state) => state.price.updateProductSalesData;
export default updateProductSalesDataSlice.reducer;